"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cross = exports.iconName = exports.paths = void 0;
exports.paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m12 13.4139 4.9497 4.9498 1.4142-1.4142-4.9497-4.9498L18.3639 7.05l-1.4142-1.4143L12 10.5855 7.0502 5.6357 5.636 7.05l4.9497 4.9497-4.9497 4.9498 1.4142 1.4142L12 13.4139z" } }];
exports.iconName = 'cross';
exports.cross = { iconName: exports.iconName, paths: exports.paths };
exports.default = exports.paths;
